import Carousel from 'bootstrap/js/dist/carousel';
let carouselslHp = []
const init_home_carousel = () => {
    console.log("init_home_carousel");
    let myCarousels = document.querySelectorAll('.homepageCarousel')
    myCarousels.forEach(function (carouselEl){
        let bsCarousel = new Carousel(carouselEl, {
            interval: 4000,
        })
        bsCarousel.cycle();
        carouselslHp.push(bsCarousel)
    })
}

const destroy_home_carousel = () => {
    console.log(carouselslHp);
    carouselslHp.forEach(function (bsCarousel){
        bsCarousel.dispose();
    })
    carouselslHp = []
}
export {init_home_carousel, destroy_home_carousel};
